import { MatPaginatorIntl } from '@angular/material/paginator';

export class CustomPaginatorLabels extends MatPaginatorIntl {
  override itemsPerPageLabel = 'Elementos por página:';
  override nextPageLabel = 'Página siguiente';
  override firstPageLabel = 'Primera página';
  override lastPageLabel = 'Última página';
  override previousPageLabel = 'Página anterior';
  override getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return `0 de ${length}`;
    }

    const startIndex = page * pageSize + 1;
    const endIndex = startIndex + pageSize - 1;
    const rangeLabel = `${startIndex} - ${endIndex}`;
    return `${rangeLabel} de ${length}`;
  };

}